(() => {
  const getRootUrl = (el) => {
    const raw = el.dataset.rootUrl || el.dataset.baseUrl || '/';
    return raw.endsWith('/') ? raw : `${raw}/`;
  };

  const getCurrentVariantId = (el) => {
    // 1) If theme updates URL with ?variant=
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get('variant');
    if (fromUrl) return String(fromUrl);

    // 2) Current product form hidden input (DO NOT CACHED)
    // Prefer closest form, but fall back to any add-to-cart form on page.
    const closestForm =
      el.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const input = closestForm?.querySelector('input[name="id"]');
    const fromInput = input?.value;
    if (fromInput) return String(fromInput);

    // 3) fallback to existing dataset
    return el.dataset.variantId ? String(el.dataset.variantId) : null;
  };

  const removeDrawer = () => {
    const drawer = document.querySelector('pickup-availability-drawer');
    if (drawer) drawer.remove();
  };

  if (!customElements.get('pickup-availability')) {
    customElements.define(
      'pickup-availability',
      class PickupAvailability extends HTMLElement {
        constructor() {
          super();

          this.errorHtml = this.querySelector('template')?.content?.firstElementChild?.cloneNode(true);
          this.onClickRefreshList = this.onClickRefreshList.bind(this);

          this._lastVariantId = null;

          // Initial
          this.syncAndFetch();

          // Listen for changes inside product form (covers swatches/buttons/selects)
          this._onInteraction = () => this.syncAndFetch();
          document.addEventListener('change', this._onInteraction, true);
          document.addEventListener('click', this._onInteraction, true);

          // Watch URL changes (some themes update ?variant= without full reload)
          this._onPopState = () => this.syncAndFetch();
          window.addEventListener('popstate', this._onPopState);

          // Watch DOM replacement (Dawn re-renders product-info)
          this._observer = new MutationObserver(() => this.syncAndFetch());
          this._observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['value'],
          });
        }

        disconnectedCallback() {
          document.removeEventListener('change', this._onInteraction, true);
          document.removeEventListener('click', this._onInteraction, true);
          window.removeEventListener('popstate', this._onPopState);
          if (this._observer) this._observer.disconnect();
        }

        syncAndFetch() {
          const variantId = getCurrentVariantId(this);
          if (!variantId) return;

          // If variant changed, refetch and reset drawer
          if (variantId !== this._lastVariantId) {
            this._lastVariantId = variantId;
            this.dataset.variantId = variantId;

            removeDrawer();

            // Optional: clear preview while loading
            // this.innerHTML = '';
            // this.removeAttribute('available');

            this.fetchAvailability(variantId);
          }
        }

        fetchAvailability(variantId) {
          const rootUrl = getRootUrl(this);
          const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

          fetch(variantSectionUrl)
            .then((r) => r.text())
            .then((text) => {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const section = doc.querySelector('.shopify-section') || doc;
              this.renderPreview(section);
            })
            .catch(() => this.renderError());
        }

        onClickRefreshList() {
          this.fetchAvailability(this.dataset.variantId);
        }

        renderError() {
          this.innerHTML = '';
          if (this.errorHtml) this.appendChild(this.errorHtml);

          const btn = this.querySelector('button');
          if (btn) btn.addEventListener('click', this.onClickRefreshList);
        }

        renderPreview(section) {
          removeDrawer();

          const preview = section.querySelector('pickup-availability-preview');
          const drawer = section.querySelector('pickup-availability-drawer');

          if (!preview || !drawer) {
            this.innerHTML = '';
            this.removeAttribute('available');
            return;
          }

          this.innerHTML = preview.outerHTML;
          this.setAttribute('available', '');
          document.body.appendChild(drawer);

          const btn = this.querySelector('button');
          if (btn) {
            btn.addEventListener('click', (evt) => {
              const d = document.querySelector('pickup-availability-drawer');
              if (d) d.show(evt.target);
            });
          }
        }
      }
    );
  }

  if (!customElements.get('pickup-availability-drawer')) {
    customElements.define(
      'pickup-availability-drawer',
      class PickupAvailabilityDrawer extends HTMLElement {
        constructor() {
          super();

          this.onBodyClick = this.handleBodyClick.bind(this);

          const closeBtn = this.querySelector('button');
          if (closeBtn) closeBtn.addEventListener('click', () => this.hide());

          this.addEventListener('keyup', (event) => {
            if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
        }

        handleBodyClick(evt) {
          const target = evt.target;
          if (target !== this && !target.closest('pickup-availability-drawer') && target.id !== 'ShowPickupAvailabilityDrawer') {
            this.hide();
          }
        }

        hide() {
          this.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClick);
          document.body.classList.remove('overflow-hidden');
          if (typeof removeTrapFocus === 'function') removeTrapFocus(this.focusElement);
        }

        show(focusElement) {
          this.focusElement = focusElement;
          this.setAttribute('open', '');
          document.body.addEventListener('click', this.onBodyClick);
          document.body.classList.add('overflow-hidden');
          if (typeof trapFocus === 'function') trapFocus(this);
        }
      }
    );
  }
})();
